import {
  Companion_getInstance39he8wfhznx8z as Companion_getInstance,
  Payout257apsotr6b9a as Payout,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MonetaryValue3pm7jom4inigc as MonetaryValue } from './supportModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function preparePayoutFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Payout__id_getInstance(), Payout_totalOut_getInstance(), Payout_onePercent_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Payout__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Payout__id$_get_name_$ref_q1m6y6() {
  return (p0) => p0.k20();
}
function Payout__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Payout__id$_get_serializer_$ref_bib8vf() {
  return (p0) => p0.j2j();
}
function Payout__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Payout__id$_get_annotations_$ref_ehkpc7() {
  return (p0) => p0.bz();
}
var Payout__idClass;
function Payout__id() {
  if (Payout__idClass === VOID) {
    class $ {
      constructor() {
        Payout__id_instance = this;
        var tmp = this;
        tmp.c71_1 = lazy(Payout__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d71_1 = lazy(Payout__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e71_1 = lazy(Payout__id$annotations$delegate$lambda);
        this.f71_1 = System_instance.d1m();
        this.g71_1 = 'System.now()';
      }
      k20() {
        var tmp0 = this.c71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Payout__id$_get_name_$ref_q1m6y6(), null);
        return tmp0.f2();
      }
      h71(receiver) {
        return receiver.i71_1;
      }
      m2j(receiver) {
        return this.h71(receiver instanceof Payout() ? receiver : THROW_CCE());
      }
      l71(receiver, value) {
        return receiver.m71(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Payout() ? receiver : THROW_CCE();
        return this.l71(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Payout__id$_get_serializer_$ref_bib8vf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Payout__id$_get_annotations_$ref_ehkpc7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Payout__id', VOID, VOID, [SerializableProperty()]);
    Payout__idClass = $;
  }
  return Payout__idClass;
}
var Payout__id_instance;
function Payout__id_getInstance() {
  if (Payout__id_instance === VOID)
    new (Payout__id())();
  return Payout__id_instance;
}
function Payout_totalOut$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Payout_totalOut$_get_name_$ref_zfoq8() {
  return (p0) => p0.k20();
}
function Payout_totalOut$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Payout_totalOut$_get_serializer_$ref_g9gz6f() {
  return (p0) => p0.j2j();
}
function Payout_totalOut$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Payout_totalOut$_get_annotations_$ref_n1iz7p() {
  return (p0) => p0.bz();
}
var Payout_totalOutClass;
function Payout_totalOut() {
  if (Payout_totalOutClass === VOID) {
    class $ {
      constructor() {
        Payout_totalOut_instance = this;
        var tmp = this;
        tmp.n71_1 = lazy(Payout_totalOut$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o71_1 = lazy(Payout_totalOut$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p71_1 = lazy(Payout_totalOut$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.n71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Payout_totalOut$_get_name_$ref_zfoq8(), null);
        return tmp0.f2();
      }
      q71(receiver) {
        return receiver.j71_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.q71(receiver instanceof Payout() ? receiver : THROW_CCE()));
      }
      r71(receiver, value) {
        return receiver.m71(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Payout() ? receiver : THROW_CCE();
        return this.r71(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Payout_totalOut$_get_serializer_$ref_g9gz6f(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Payout_totalOut$_get_annotations_$ref_n1iz7p(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Payout_totalOut', VOID, VOID, [SerializableProperty()]);
    Payout_totalOutClass = $;
  }
  return Payout_totalOutClass;
}
var Payout_totalOut_instance;
function Payout_totalOut_getInstance() {
  if (Payout_totalOut_instance === VOID)
    new (Payout_totalOut())();
  return Payout_totalOut_instance;
}
function Payout_onePercent$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Payout_onePercent$_get_name_$ref_mpr9id() {
  return (p0) => p0.k20();
}
function Payout_onePercent$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Payout_onePercent$_get_serializer_$ref_x7gss4() {
  return (p0) => p0.j2j();
}
function Payout_onePercent$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Payout_onePercent$_get_annotations_$ref_iw6y1c() {
  return (p0) => p0.bz();
}
var Payout_onePercentClass;
function Payout_onePercent() {
  if (Payout_onePercentClass === VOID) {
    class $ {
      constructor() {
        Payout_onePercent_instance = this;
        var tmp = this;
        tmp.s71_1 = lazy(Payout_onePercent$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t71_1 = lazy(Payout_onePercent$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u71_1 = lazy(Payout_onePercent$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.s71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Payout_onePercent$_get_name_$ref_mpr9id(), null);
        return tmp0.f2();
      }
      q71(receiver) {
        return receiver.k71_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.q71(receiver instanceof Payout() ? receiver : THROW_CCE()));
      }
      r71(receiver, value) {
        return receiver.m71(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Payout() ? receiver : THROW_CCE();
        return this.r71(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Payout_onePercent$_get_serializer_$ref_x7gss4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Payout_onePercent$_get_annotations_$ref_iw6y1c(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Payout_onePercent', VOID, VOID, [SerializableProperty()]);
    Payout_onePercentClass = $;
  }
  return Payout_onePercentClass;
}
var Payout_onePercent_instance;
function Payout_onePercent_getInstance() {
  if (Payout_onePercent_instance === VOID)
    new (Payout_onePercent())();
  return Payout_onePercent_instance;
}
//region block: exports
export {
  preparePayoutFields as preparePayoutFields2wdvzk40fr45j,
};
//endregion

//# sourceMappingURL=PayoutFields.mjs.map
